/**
 * @file: Asset.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 资产登记管理
 */
import request from '@/utils/request'

/**
 * 新增资产信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetAdd(data) {
  return request({
    type: 'biz',
    url: 'asset/add',
    method: 'post',
    data
  })
}

/**
 * 删除资产信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetDelete(data) {
  return request({
    type: 'biz',
    url: 'asset/delete',
    method: 'post',
    data
  })
}

/**
 * 新增资产数据字典
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetDictionaryAdd(data) {
  return request({
    type: 'biz',
    url: 'asset/dictionary/add',
    method: 'post',
    data
  })
}

/**
 * 根据学校ID（组织ID）获取资产数据字典列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetDictionaryByDeptListGet(data) {
  return request({
    type: 'biz',
    url: 'asset/dictionary/by/dept/list/get',
    method: 'post',
    data
  })
}

/**
 * 删除资产数据字典
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetDictionaryDelete(data) {
  return request({
    type: 'biz',
    url: 'asset/dictionary/delete',
    method: 'post',
    data
  })
}

/**
 * 根据主键ID获取资产数据字典
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetDictionaryGet(data) {
  return request({
    type: 'biz',
    url: 'asset/dictionary/get',
    method: 'post',
    data
  })
}

/**
 * 获取资产数据字典列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetDictionaryListGet(data) {
  return request({
    type: 'biz',
    url: 'asset/dictionary/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改资产数据字典
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetDictionaryUpdate(data) {
  return request({
    type: 'biz',
    url: 'asset/dictionary/update',
    method: 'post',
    data
  })
}

/**
 * 根据主键ID获取资产信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetGet(data) {
  return request({
    type: 'biz',
    url: 'asset/get',
    method: 'post',
    data
  })
}

/**
 * 获取资产信息列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetListGet(data) {
  return request({
    type: 'biz',
    url: 'asset/list/get',
    method: 'post',
    data
  })
}

/**
 * 食堂设备总览
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetStatistics(data) {
  return request({
    type: 'biz',
    url: 'asset/statistics',
    method: 'post',
    data
  })
}

/**
 * 修改资产信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function assetUpdate(data) {
  return request({
    type: 'biz',
    url: 'asset/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Asset.js